<template>
  <div style="width: 100%; height: 100%">

    <el-form ref="form" :model="form" style="margin-top:0px;margin-left:20px" :inline="true" size="medium">
      <el-row style="margin-left: 0px; width: 1034.5px;">

        <el-form-item label="抬头信息:">
          <el-input v-model="form.lookUpMessage" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称:">
          <el-input v-model="form.supplierName" size="small" style="width:300px"></el-input>
        </el-form-item>

        <el-form-item label="单据类型:">
          <el-radio v-model="form.TYPE" label="1">短打印</el-radio>
          <el-radio v-model="form.TYPE" label="2">长打印</el-radio>
        </el-form-item>
      </el-row>
      <el-row style="margin-left: 0px; width: 1034.5px;">
        <el-form-item class="默认设置">
          默认设置:
          <el-checkbox v-model="checked1" name="type" disabled>产品名称</el-checkbox>
          <el-checkbox v-model="checked2" name="type" disabled>单位</el-checkbox>
          <el-checkbox label="二维码显示" v-model="form.checked3" name="type"></el-checkbox>
        </el-form-item>
        <el-form-item label="非标品单位:" style="float: right;">
          <el-radio v-model="form.NONSTANDARD_PRODUCT_USE_KG" :label="1">KG</el-radio>
          <el-radio v-model="form.NONSTANDARD_PRODUCT_USE_KG" :label="0">斤</el-radio>
        </el-form-item>
      </el-row>
      <div style="display:flex;margin-left: 0px;">
        <el-col :span="4">
          <el-form-item>
            参数设置:<span class="count">{{ lookUpLength }}/8</span>
            <el-checkbox-group v-model="form.lookUp" :max="8">
              <el-checkbox label="项目点" name="type"></el-checkbox>
              <el-checkbox label="档口" name="type"></el-checkbox>
              <el-checkbox label="供应商" name="type"></el-checkbox>
              <el-checkbox label="收货方" name="type"></el-checkbox>
              <el-checkbox label="委托方" name="type"></el-checkbox>
              <el-checkbox label="配送方" name="type"></el-checkbox>
              <el-checkbox label="送货日期" name="type"></el-checkbox>
              <el-checkbox label="制单人" name="type"></el-checkbox>
              <el-checkbox label="联系人" name="type"></el-checkbox>
              <el-checkbox label="订单编号" name="type"></el-checkbox>
              <el-checkbox label="订单ID" name="type"></el-checkbox>
              <el-checkbox label="项目点地址" name="type"></el-checkbox>
              <el-checkbox label="回单日期" name="type"></el-checkbox>
              <el-checkbox label="总金额" name="type"></el-checkbox>
              <el-checkbox label="订单备注" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item>
            表格设置:
            <span class="count">{{ tableSetLength }}/{{ newtableSetLength }}</span>
            <el-checkbox-group v-model="form.tableSet" :max="newtableSetLength" @change="getSetLength">
              <el-checkbox label="产品编码" name="type"></el-checkbox>
              <el-checkbox label="使用短名" name="type"></el-checkbox>
              <template v-if="getShort == 1">
                <el-checkbox label="品牌" name="type"></el-checkbox>
                <el-checkbox label="规格" name="type"></el-checkbox>
              </template>
              <el-checkbox label="送货数量" name="type"></el-checkbox>
              <el-checkbox label="订购数量" name="type"></el-checkbox>
              <el-checkbox label="实收数量" name="type"></el-checkbox>
              <el-checkbox label="价格" name="type"></el-checkbox>
              <el-checkbox label="送货总金额" name="type"></el-checkbox>
              <el-checkbox label="订购总金额" name="type"></el-checkbox>
              <el-checkbox label="实收总金额" name="type"></el-checkbox>
              <el-checkbox label="备注" name="type"></el-checkbox>
              <el-checkbox label="加工/生产日期" name="type"></el-checkbox>
              <el-checkbox label="保质期" name="type"></el-checkbox>
              <el-checkbox label="保质期（自动带出）" name="type"></el-checkbox>
              <el-checkbox label="税率(常用SKU销项税)" name="type"></el-checkbox>
              <el-checkbox label="生产日期(线上填写)" name="type"></el-checkbox>
              <el-checkbox label="标品生产日期" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            页脚设置:<span class="count">{{ footerSetLength }}/8</span>
            <el-checkbox-group v-model="form.footerSet" :max="8">
              <el-checkbox label="发货人员" name="type"></el-checkbox>
              <el-checkbox label="送货人员" name="type"></el-checkbox>
              <el-checkbox label="发货时间" name="type"></el-checkbox>
              <el-checkbox label="送货路线" name="type"></el-checkbox>
              <el-checkbox label="验收时间" name="type"></el-checkbox>
              <el-checkbox label="验收人员" name="type"></el-checkbox>
              <el-checkbox label="厨师长" name="type"></el-checkbox>
              <el-checkbox label="项目经理" name="type"></el-checkbox>
              <el-checkbox label="本页金额" name="type"></el-checkbox>
              <el-checkbox label="周转筐" name="type"></el-checkbox>
              <!-- 北京快客利 -->
              <el-checkbox label="送货员" name="type"></el-checkbox>
              <el-checkbox label="炊事班长" name="type"></el-checkbox>
              <el-checkbox label="给养员" name="type"></el-checkbox>
              <el-checkbox label="厨房值班员" name="type"></el-checkbox>
              <el-checkbox label="风气监督员" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </div>
      <el-form-item label="单据归属信息:">
        <el-input v-model="form.address" size="small" style="width:600px"></el-input>
      </el-form-item>
      <div>
        <el-form-item style="margin-left: 0px;">
          <el-button type="primary" @click="onSubmit">立即保存</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      TEMPLATE_ID: sessionStorage.getItem('TEMPLATE_ID'),
      checked1: true,
      checked2: true,
      tableSetLength: 0,
      newtableSetLength: 6,
      getShort: 0,
      newArr: [],
      lookUpLength: 0,
      footerSetLength: 0,
      form: {
        TEMPLATE_TYPE: 1,
        lookUpMessage: '送货验收单',
        supplierName: sessionStorage.getItem('name'),
        address: '',
        tableSet: [

        ],
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        lookUp: [
        ],
        footerSet: [],
        TYPE: '1',
        NONSTANDARD_PRODUCT_USE_KG: 1,
      },
    };
  },
  created() {
    this.queryForm();
  },
  watch: {
    'form.lookUp': function () {
      this.lookUpLength = this.form.lookUp.length;
    },
    'form.footerSet': function () {
      this.footerSetLength = this.form.footerSet.length;
    },

  },
  methods: {
    getNewTable() {
      this.form.tableSet = this.newArr;
    },
    getSetLength() {
      if (this.form.tableSet.indexOf('使用短名') != -1) {
        this.getShort = 1;
        this.newtableSetLength = 7;
        this.tableSetLength = this.form.tableSet.length;
      } else {
        this.getShort = 0;
        this.newtableSetLength = 6;
        this.form.tableSet = this.form.tableSet.filter((item) => item != '品牌' && item != '规格');
        this.tableSetLength = this.form.tableSet.length;
      }
    },
    queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 3,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TEMPLATE_ID: sessionStorage.getItem('TEMPLATE_ID'),
      };
      http.post(params).then((result) => {
        if (result.length != 0) {
          result.map((item) => {
            if (item.TEMPLATE_TYPE == 1) {
              this.form = item;
              this.form.TYPE = String(item.TYPE);
              if (this.form.tableSet.indexOf('使用短名') != -1) {
                this.getShort = 1;
                this.newtableSetLength = 7;
                this.tableSetLength = this.form.tableSet.length;
              }
              if (item.checked3 == 0) {
                this.form.checked3 = false;
              } else {
                this.form.checked3 = true;
              }
              if (item.checked4 == 0) {
                this.form.checked4 = false;
              } else {
                this.form.checked4 = true;
              }
              if (item.checked5 == 0) {
                this.form.checked5 = false;
              } else {
                this.form.checked5 = true;
              }
              if (item.checked6 == 0) {
                this.form.checked6 = false;
              } else {
                this.form.checked6 = true;
              }
            }
          });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getBand() {

    },
    onSubmit() {
      if (this.form.checked3) {
        this.form.checked3 = 1;
      } else {
        this.form.checked3 = 0;
      }
      if (this.form.checked4) {
        this.form.checked4 = 1;
      } else {
        this.form.checked4 = 0;
      }
      if (this.form.checked5) {
        this.form.checked5 = 1;
      } else {
        this.form.checked5 = 0;
      }
      if (this.form.checked6) {
        this.form.checked6 = 1;
      } else {
        this.form.checked6 = 0;
      }
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TEMPLATE_ID: sessionStorage.getItem('TEMPLATE_ID'),
        TEMPLATE_CONTENT: [this.form],
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '保存成功', type: 'success' });
        this.queryForm();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}

.el-checkbox {
  display: block;
}

.默认设置 >>> .el-checkbox {
  display: inline-block;
}

.count {
  font-size: 12px;
  color: #9c9090;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/sellOrderCustomPrint.vue